// Global "one media at a time" coordinator.
// When any player starts, pause every other <audio>/<video> and notify
// React players so they reset their button to the Play icon.

export function stopAllMediaExcept(el) {
  document.querySelectorAll("audio, video").forEach((m) => {
    if (m !== el && !m.paused) {
      try { m.pause(); } catch (e) { console.debug("mediaBus pause failed:", e); }
    }
  });
  window.dispatchEvent(new CustomEvent("eovo-media-play", { detail: { el } }));
}

export function onExclusivePlay(cb) {
  const handler = (e) => cb(e.detail ? e.detail.el : null);
  window.addEventListener("eovo-media-play", handler);
  return () => window.removeEventListener("eovo-media-play", handler);
}
